import React from "react";
import { ComplianceBand } from "@/components/Section";

const INTERIOR_IMG =
  "https://images.pexels.com/photos/32178051/pexels-photo-32178051.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const SECTIONS = [
  {
    title: "Property Holding",
    text: "The company may acquire and hold residential or commercial properties directly or indirectly through subsidiaries and partnerships.",
  },
  {
    title: "Rental Activities",
    text: "Activities may include rental operations, tenant coordination and cooperation with local property managers and service providers.",
  },
  {
    title: "Property Partnerships & Platforms",
    text: "Taonga OÜ cooperates with local real estate professionals in Tallinn and may evaluate selected property-related opportunities through established European real estate and crowdfunding platforms such as Estateguru and Crowdestate. These platforms may be used to access indirect real estate opportunities complementary to the company's broader property-related activities.",
  },
  {
    title: "Property-Related Projects",
    text: "The company may participate in selected long-term property-related projects where operational transparency and sustainable value creation are present.",
  },
  {
    title: "Supporting Internal Operations",
    text: "The company may use internal administrative, analytical and technology tools to support reporting, treasury management and operational monitoring for its own activities only.",
  },
];

const RealEstate = () => {
  return (
    <div data-testid="real-estate-page">
      {/* HERO */}
      <section className="bg-white">
        <div className="container-tight pt-16 md:pt-24 pb-12">
          <div className="max-w-3xl">
            <div className="overline reveal">Activities</div>
            <h1
              data-testid="re-title"
              className="reveal reveal-delay-1 mt-6 font-display text-4xl sm:text-5xl lg:text-[60px] font-bold tracking-tight text-navy leading-[1.05]"
            >
              Real Estate Activities
            </h1>
            <p
              data-testid="re-intro"
              className="reveal reveal-delay-2 mt-8 text-[18px] leading-relaxed text-charcoal"
            >
              Taonga OÜ focuses primarily on property-related activities and
              long-term operational projects connected to residential and
              commercial real estate.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="container-tight pb-12">
          <img
            src={INTERIOR_IMG}
            alt="Modern residential interior"
            className="w-full h-[320px] md:h-[480px] object-cover rounded-md border border-border"
            loading="lazy"
            data-testid="re-image"
          />
        </div>
      </section>

      {/* NUMBERED SECTIONS */}
      <section className="section bg-soft" data-testid="re-sections">
        <div className="container-tight">
          <div className="space-y-2">
            {SECTIONS.map((s, idx) => (
              <article
                key={s.title}
                data-testid={`re-section-${idx + 1}`}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 py-10 md:py-12 border-b border-border last:border-b-0 transition-colors"
              >
                <div className="lg:col-span-3">
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-5xl font-bold text-warm/70 leading-none">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>
                </div>
                <div className="lg:col-span-9">
                  <h2 className="font-display text-2xl sm:text-3xl font-semibold text-navy tracking-tight transition-colors group-hover:text-navy">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-[16px] leading-relaxed text-charcoal max-w-3xl">
                    {s.text}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ComplianceBand testId="re-compliance-band">
        Internal administrative, analytical and technology tools are used
        exclusively to support the company's own operational and treasury
        activities. Taonga OÜ does not provide regulated financial services or
        manage third-party assets.
      </ComplianceBand>
    </div>
  );
};

export default RealEstate;
